import { render, staticRenderFns } from "./WeekDayItem.vue?vue&type=template&id=590ac660&scoped=true&"
import script from "./WeekDayItem.vue?vue&type=script&lang=js&"
export * from "./WeekDayItem.vue?vue&type=script&lang=js&"
import style0 from "./WeekDayItem.vue?vue&type=style&index=0&id=590ac660&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ac660",
  null
  
)

export default component.exports